import { render, staticRenderFns } from "./DocumentPicker.vue?vue&type=template&id=35db228a&scoped=true&"
import script from "./DocumentPicker.vue?vue&type=script&lang=js&"
export * from "./DocumentPicker.vue?vue&type=script&lang=js&"
import style0 from "./DocumentPicker.vue?vue&type=style&index=0&id=35db228a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35db228a",
  null
  
)

export default component.exports